import { render, staticRenderFns } from "./editGold.vue?vue&type=template&id=1e17ccb2&scoped=true"
import script from "./editGold.vue?vue&type=script&lang=js"
export * from "./editGold.vue?vue&type=script&lang=js"
import style0 from "./editGold.vue?vue&type=style&index=0&id=1e17ccb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e17ccb2",
  null
  
)

export default component.exports